var map = {
	"./1742112133133.jpg": 1069,
	"./1742113242276.jpg": 1791,
	"./1742113242495.jpg": 3224,
	"./gal1.jpg": 5356,
	"./gal2.jpg": 8155,
	"./gal3.jpg": 7998,
	"./gal4.jpg": 885,
	"./gal5.jpg": 3272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;